export const PROJECT_COLOR_PALETTE = [
  "#7C3AED",
  "#06B6D4",
  "#10B981",
  "#F59E0B",
  "#E11D48",
  "#2563EB",
  "#DB2777",
  "#0D9488",
  "#D97706",
  "#4338CA",
];

/**
 * Deterministic project color derived from the project name.
 * The backend timesheet entries do not carry a color field, so this
 * stable hash-encoding keeps a project consistent across day cards,
 * the segmented bar and the legend.
 */
export function projectColor(project?: string): string {
  const key = String(project || "").trim();
  if (!key) return PROJECT_COLOR_PALETTE[0];
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) {
    hash = (hash * 31 + key.charCodeAt(i)) | 0;
  }
  return PROJECT_COLOR_PALETTE[Math.abs(hash) % PROJECT_COLOR_PALETTE.length];
}